import * as prismic from '@prismicio/client'

// Fill in your repository name
export const repositoryName = 'creatorcoin'
const endpoint = prismic.getRepositoryEndpoint(repositoryName);
const client = prismic.createClient(endpoint);

export default client;